import {Component, Input} from "@angular/core";
import {GridsterConfig, GridsterItem} from "angular-gridster2";
import {WidgetButton} from "./WidgetButton";
import {BaseComponent} from "../../BaseComponent";

/**
 * This is the base widget component, an abstract class that is extended every time a developer has to create a new dashboard-editor widget
 */
@Component({
  selector: 'app-base-widget',
  template: `NO-UI`,
})
export abstract class BaseWidgetComponent extends BaseComponent {

  /**
   * Name of the widget
   */
  name!: string;
  /**
   * Gridster item reference
   */
  @Input('gridsterItem') gridsterItem!: GridsterItem;
  /**
   * Gridster options reference
   */
  @Input('gridsterOptions') gridsterOptions!: GridsterConfig;

  /**
   * The buttons of the widget placed in the header of the widget
   */
  widgetButtons = new Array<WidgetButton>();

  abstract checkWidgetMetricsExistence(): void;

}
